import { Flex } from 'antd'
import React from 'react'

import SectionTitle from '../section-title'

import ChatterPerformanceChart, {
  ChartData,
  StrokeColors,
} from './chatter-performance-line-chart'

export interface ChatterPerformanceUnlockRatioProps {
  data: ChartData
}

export default function ChatterPerformanceUnlockRatio(props: ChatterPerformanceUnlockRatioProps) {

  return (
    <Flex vertical gap={8}>
      <SectionTitle
        title="Unlock ratio"
        tooltip="The ratio between total PPVs sent and total PPVs purchased by fans during this period"
      />
      <ChatterPerformanceChart data={props.data} isSmooth={false} stroke={StrokeColors.UnlockRatio} />
    </Flex>
  )

}